import { render, staticRenderFns } from "./authorIndex.vue?vue&type=template&id=866b1ee4&scoped=true&"
import script from "./authorIndex.vue?vue&type=script&lang=js&"
export * from "./authorIndex.vue?vue&type=script&lang=js&"
import style0 from "./authorIndex.vue?vue&type=style&index=0&id=866b1ee4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866b1ee4",
  null
  
)

export default component.exports